import { api } from 'api';
import { call } from 'redux-saga/effects';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Rejects a suggestion via Suggestion_Reject. The endpoint returns no
// payload — callers (sagas) refetch the suggestion domain afterwards via
// initializeSuggestions to surface the new status.
export function* rejectSuggestion(args: { suggestionId: string }) {
  const { suggestionId } = args;

  function* work(tenantId: string) {
    yield call(api.rejectSuggestion, { tenantId, suggestionId });
  }

  yield call(operationWrapper, work, JwtFeature.Improvements);
}
